import {Component, CUSTOM_ELEMENTS_SCHEMA, input} from '@angular/core';
import {DynamicComponentBase} from '../../service/ng-dynamic-components.service';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [],
    template: `
        <div class="tooltip-content">
            {{text()}}
        </div>
    `,
    styles: [`
        div.tooltip-content {
            display: block;
            padding: 8px;
            background-color: lightgoldenrodyellow;
        }
        `
    ]
})
export class TextTooltipComponent extends DynamicComponentBase {

    public readonly text = input<string>('');

    constructor() {
        super();
    }
}
